app.controller(
    'SearchController', ['$scope', SearchController]
);

function SearchController($scope) {
}
